import { useEffect, useMemo, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { OrderConversionRequestParams } from 'config/requests/orderConversion';
import { useQueryFilters } from 'hooks/useQueryFilters';
import { ConversionPeriod } from 'pages/Monitoring/OrderConversion/OrderConversionList/OrderConversionListPeriodToggle/OrderConversionListPeriodToggle';
import { Identifier } from 'react-admin';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { getId } from 'utils';
import { cleanEmpty } from 'utils/cleanEmpty';
import * as yup from 'yup';

export type OrderConversionListFormValues = {
  merchant: string | null;
  gateway: string[];
  provider: string[];
  period: string;
  direction: string | null;
};

const INITIAL_FILTERS = {
  merchant: null,
  gateway: [],
  provider: [],
  direction: null,
};

export const useOrderConversionFilter = () => {
  const { setQueryFilterString, queryFilterObject, isEmptyFilters } = useQueryFilters();
  const [period, setPeriodState] = useState<ConversionPeriod>(
    queryFilterObject?.period || ConversionPeriod.Hour12,
  );

  const {
    form,
    onSubmit: onSubmitFilters,
    onReset: onResetFilters,
    appliedFilters,
    setAppliedFilter,
    openDrawer,
    toggleDrawer,
  } = useFilters<OrderConversionListFormValues>({
    resolver: yupResolver<any>(
      yup.object().shape({
        merchant: yup.string().required('Обязательное поле'),
      }),
    ),
    defaultValues: queryFilterObject || INITIAL_FILTERS,
    resetValues: INITIAL_FILTERS,
  });

  const setPeriod = (value: ConversionPeriod) => {
    setPeriodState(value);
    setQueryFilterString(cleanEmpty({ ...queryFilterObject, period: value }));
  };

  const onSubmit = (values: OrderConversionListFormValues) => {
    setQueryFilterString(cleanEmpty(values));
    onSubmitFilters(values);
  };

  const onReset = () => {
    setQueryFilterString({});
    onResetFilters();
  };

  const params = useMemo<OrderConversionRequestParams>(() => {
    return cleanEmpty({
      gatewayIds: appliedFilters?.gateway?.map((hydraId) => getId(hydraId)),
      providerIds: appliedFilters?.provider?.map((hydraId) => getId(hydraId)),
      period,
      merchantId: getId(appliedFilters?.merchant as Identifier),
      direction: appliedFilters?.direction,
    }) as OrderConversionRequestParams;
  }, [period, appliedFilters]);

  useEffect(() => {
    if (isEmptyFilters) {
      onReset();
    }
  }, [isEmptyFilters]);

  const isListFilterExist = Object.keys(cleanEmpty(appliedFilters)).length > 0;

  return {
    params,
    form,
    setPeriod,
    onSubmit,
    toggleDrawer,
    isListFilterExist,
    period,
    openDrawer,
    appliedFilters,
    setAppliedFilter,
    onReset,
  };
};
